export const FB_LINK = "https://www.facebook.com/kagerlighedkbh";
export const INSTA_LINK = "https://www.instagram.com/kagerlighed.kbh/?igshid=YmMyMTA2M2Y%3D";
export const KAGERLIGHED_KBH = "kagerlighed.kbh";